import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbAddressTileComponent } from './mb-address-tile.component'
import { MbI18nModule } from '../../../translations/mb-i18n.module'
import { MbEmptyAddressTileComponent } from './mb-empty-address-tile/mb-empty-address-tile.component'
import { LinkModule } from '../../../cms/components/shared/link/link.module'

@NgModule({
  declarations: [
    MbAddressTileComponent,
    MbEmptyAddressTileComponent
  ],
  imports: [
    CommonModule,
    MbI18nModule,
    LinkModule
  ],
  exports: [
    MbAddressTileComponent,
    MbEmptyAddressTileComponent
  ]
})
export class MbAddressTileModule {}
